export default __webpack_public_path__ + "static/media/ackreport.3fa85810.svg";